import translations from "./GoodsTypesTranslations.json";
import { translate } from "@flow-frontend-npm/common";

/**
 * Simplified call off translate
 * @param {string} key
 * @return {string} translation
 */
const t = (key) => translate(translations, key);

const goodsTypes = {
    BULK: {
        code: "L",
        label: t("goodsType.bulk"),
    },
    PACKAGED: {
        code: "V",
        label: t("goodsType.packaged"),
    },
    MIXED: {
        code: "X",
        label: t("goodsType.mixed"),
    },
    NO_GOODS: {
        code: "W",
        label: t("goodsType.noGoods"),
    },
};

export default goodsTypes;

export function getGoodsTypeLabelByCode(code) {
    const found = Object.values(goodsTypes).find((type) => type.code === code);
    return found ? found.label : "";
}
